<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  props: {
    id: {
      type: String,
      value: "",
    },
    typeId: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      mname: "work",
      key: "id",
      url: {
        //   get: '/admin/system/inventory',
        // add: '/admin/system/inventory',
        // add: '/admin/system/inventory/receive',
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "派单",
          name: "maintainerId",
          value: "",
          type: "select",
          width: "240px",
          dropList: [],
          rules: [{ required: true,message: "维修员不能为空", trigger: "blur", type: "number" }],
        },
      ],
      forms: {
        id: this.id,
        typeId:this.typeId
      },
    };
  },
  created() {
    this.loaduserData();
  },
  methods: {
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/work`, q, "PUT")
            .then((res) => {
              this.sloading = false;
              console.log(res);
              if (res.status) {
                $utils.toast.success("保存成功");
              }
              this.$Modal.remove();
              /* setTimeout(() => {
                $utils.url.go(0);
              }, 2000); */
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
              this.$Modal.remove();
              setTimeout(() => {
                $utils.url.go(0);
              }, 2000);
            });
        }
      });
    },
    loaduserData() {
      // 通过pk查询字典数据
    let  typeId = this.typeId
      $utils.api.load(`/admin/system/maiUser/type/${typeId}`).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.userId;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "maintainerId") {
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
  },
};
</script>
